import * as React from 'react'
import { Trans } from 'react-i18next'
import { Modal, Button } from 'react-bootstrap'

import ResponsiveScroller from 'src/components/system_wide/responsive_scroller'
import ImageViewer from './image_viewer'

import styles from './styles.module.css'

const initialState = {
  title: '',
  url: '',
  pageNumber: 1,
  scale: 1,
  numPages: 1,
  mime_type: '',
  show: false,
  has_errors: false,
  loading: true,
}

class DocumentPreview extends React.Component {
  state = { ...initialState }

  showModal = ({ url, mime_type, title }) => {
    this.setState({ show: true, url, mime_type, title })
  }
  closeModal = () => this.setState({ ...initialState })

  onImgLoadSuccess = () => this.setState({ loading: false })
  onLoadError = () => this.setState({ has_errors: true, loading: false })

  render() {
    let { scale, url, show, mime_type, title, has_errors, loading } = this.state
    let is_img = /^image/.test(mime_type)
    let unsupported_file = !is_img

    return (
      <Modal
        backdrop="static"
        size="lg"
        centered
        show={show}
        onHide={this.closeModal}
        contentClassName={styles.preview_modal}>
        <Modal.Header>{title}</Modal.Header>
        <Modal.Body className="d-flex p-0">
          <ResponsiveScroller disableMediaQuery={true}>
            <div className="flex-fill p-3 d-flex justify-content-center align-items-center bg-light">
              {unsupported_file === false && show === true && loading === true && (
                <div className="with-shadow p-2 bg-white">
                  <Trans i18nKey="system_wide.document_preview.loading">Loading preview...</Trans>
                </div>
              )}
              {show === true && (unsupported_file || has_errors) && (
                <div className="with-shadow p-2 bg-white">
                  <Trans i18nKey="system_wide.document_preview.load_error">Unable to load preview</Trans>
                </div>
              )}

              {is_img && !has_errors && (
                <ImageViewer
                  src={url}
                  scale={scale}
                  onLoadSuccess={this.onImgLoadSuccess}
                  onLoadError={this.onLoadError}
                />
              )}
            </div>
          </ResponsiveScroller>
        </Modal.Body>
        <Modal.Footer>
          <div className="flex-fill"></div>
          <div>
            <Button variant="secondary" onClick={this.closeModal}>
              <Trans i18nKey="buttons.lose">Chiudi</Trans>
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default DocumentPreview
